module.exports = __webpack_public_path__ + "fonts/Mulish-ExtraBoldItalic.0fd05194.ttf";